import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions
} from "@mui/material";

import { mockEstados, mockGeneros, mockEstadoCivil, mockNacionalidade, mockParticipacoes } from '../mock';
import { serviceRecuperaCidades, serviceViaCep, serviceRecuperaQuantidadeRejeitados } from '../Service/service';
import { formatoMascaras, aplicaMascara, validateCPF } from '../util';
import limiteTamanhoCampos from '../limiteCampos';

const generos = mockGeneros();
const estadosCivis = mockEstadoCivil();
const estados = mockEstados();
const listaNacionalidade = mockNacionalidade();
const listaPartirticipacoes = mockParticipacoes();

const FormularioDados = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(props.formData);
  const [listaCidades, setListaCidades] = useState([]);
  const [cidadeTemp, setCidadeTemp] = useState(null);
  const refNacional = "nacional";
  const [dialogDocInvalido, setDialogDocInvalido] = useState(false);

  const [validacao, setValidacao] = useState(
    {
      nomeCompleto: false,
      cpf: props.nacionalidade == refNacional ? false : true,
      dataNascimento: false,
      identidade: false,
      orgaoExpedidor: false,
      nacionalidade: false,
      genero: false,
      estadoCivil: false,
      // menorDe15: false,
      // falecido: false,

      nomeRepresentanteQuinze: false,
      cpfRepresentanteQuinze: false,

      dtFalecimentoOutorganteFalecido: false,
      nomeOutorganteFalecido: false,
      cpfOutorganteFalecido: false,
      nacionalidadeOutorganteFalecido: false,
      rgOutorganteFalecido: false,
      rgOEOutorganteFalecido: false,
      estadoCivilOutorganteFalecido: false,
      cepOutorganteFalecido: false,
      endecoOutorganteFalecido: false,
      numeroOutorganteFalecido: false,
      estadoOutorganteFalecido: false,
      cidadeJuridicaDocOutorganteFalecido: false,
      bairroJuridicaDocOutorganteFalecido: false,
    });

  useEffect(() => {
    validaForm();
    props.onChildDataChange(formData);
  }, [formData]);

  const DATA_MINIMA_NASCIMENTO = '1900-01-01';

  const getDataAtualISO = () => {
    const hoje = new Date();

    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const dia = String(hoje.getDate()).padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
  };

  const validaDataNascimento = (data) => {
    if (!data) return false;

    return data >= DATA_MINIMA_NASCIMENTO && data <= getDataAtualISO();
  };

  useEffect(() => {
    validaForm();

    if (formData && formData.estadoOutorganteFalecido)
      atualizaCidades(formData.estadoOutorganteFalecido);

    if (props.nacionalidade == refNacional) {
      setFormData((prevState) => {
        const updatedState = {
          ...prevState,
        };
        updatedState.nacionalidade = listaNacionalidade.find(t => t.id == 76);
        return updatedState;
      });
    }

  }, []);

  const validaForm = () => {
    const propriedades = Object.keys(validacao);
    const novaValidacao = { ...validacao };
    const seEstrangeiro = !(props.nacionalidade == refNacional || formData?.nacionalidade?.id == 76);

    propriedades.forEach(propriedade => {
      if (formData) {
        const seNaoCabeValidacaoQuinze = formData?.menorDe15 != 'true' && propriedade.includes('RepresentanteQuinze');
        const seNaoCabeValidacaoFalecido = formData?.falecido != 'true' && propriedade.includes('OutorganteFalecid');
        const seNaoValidaCPF = seEstrangeiro && propriedade == 'cpf';
        const cpfInvalido = propriedade == 'cpf' && formData?.nacionalidade?.id == 76 && !validateCPF(formData[propriedade]);

        if (propriedade === 'dataNascimento') {
          novaValidacao[propriedade] = validaDataNascimento(formData?.dataNascimento);
          return;
        }

        if (cpfInvalido && formData[propriedade] && formData[propriedade].length >= formatoMascaras().CPF.length) {
          setDialogDocInvalido(true);
          novaValidacao[propriedade] = false;
        }
        else if (cpfInvalido) {
          novaValidacao[propriedade] = false;
        }
        else if (!(seNaoCabeValidacaoQuinze || seNaoCabeValidacaoFalecido || seNaoValidaCPF)) {
          novaValidacao[propriedade] = formData[propriedade] !== "" &&
            formData[propriedade] != undefined &&
            formData[propriedade] != null;
        }
        else {
          novaValidacao[propriedade] = true;
        }
      }
    });

    setValidacao(novaValidacao);
  };

  const handleChange = (event, selectRequired) => {
    let { name, value, type, required } = event.target;

    value = limiteTamanhoCampos(name, value);

    if (name == 'estadoOutorganteFalecido')
      atualizaCidades(value);

    if (name == 'cpf' || name == 'cpfRepresentanteQuinze' || name == 'cpfOutorganteFalecido')
      value = aplicaMascara(value, formatoMascaras().CPF)

    if ((name == 'identidade' && (props.nacionalidade == refNacional || formData?.nacionalidade?.id == 76)) || (name == 'rgOutorganteFalecido' && formData?.nacionalidadeOutorganteFalecido?.id == 76) || name == 'rgRepresentanteQuinze')
      value = aplicaMascara(value, value.replace(/\D/g, '').length <= 9 ? formatoMascaras().RG : formatoMascaras().RGNovo)

    if (name == 'celularRepresentanteQuinze')
      value = aplicaMascara(value, formatoMascaras().TEL)

    if (name == 'cepOutorganteFalecido')
      value = aplicaMascara(value, formatoMascaras().CEP)

    if (name == 'cepOutorganteFalecido' && value.length >= 'xxxxx-xxx'.length)
      recuperaPorCep(value)

    if (name == 'cpf' && value.length >= formatoMascaras().CPF.length)
      recuperaFiliacoesRecusadas(value)

    setFormData((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };

      if (name === 'estadoOutorganteFalecido') {
        updatedState.cidadeJuridicaDocOutorganteFalecido = '';
        atualizaCidades(value);
      }

      return updatedState;
    });

    if (required)
      setValidacao({
        ...validacao,
        [name]: type === 'text' ? value && value.toString().trim() !== '' : value,
      });

    if (selectRequired)
      setValidacao({
        ...validacao,
        [name]: value && value.toString().trim() !== '',
      });
  };

  const atualizaCidades = async (estado) => {
    try {
      const cidades = await serviceRecuperaCidades(estado);
      if (cidades)
        setListaCidades(cidades.map(t => { return { id: t.nuSeqRegWebCd, nome: t.nmCidade } }));
    } catch (error) {

    }
  }

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      if (Object.values(validacao).some(value => !value)) {
        return false;
      }
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  const recuperaFiliacoesRecusadas = (cpf) => {
    try {
      serviceRecuperaQuantidadeRejeitados(cpf.replace(/\D/g, ''), (filiacoesRecusadas) => {
        const bloquear = typeof filiacoesRecusadas === 'number' && filiacoesRecusadas > 0;
        props.setBloqueioPorCPFCNPJ(bloquear);
      });
    } catch (error) {
      console.error('Erro ao recuperar filiações recusadas:', error);
    }
  }

  const recuperaPorCep = async (cep) => {
    serviceViaCep(cep, function (dadosEndereco) {

      setFormData((prevState) => {
        const updatedState = {
          ...prevState,
        };

        updatedState.endecoOutorganteFalecido = dadosEndereco.logradouro;
        updatedState.bairroJuridicaDocOutorganteFalecido = dadosEndereco.bairro;
        updatedState.estadoOutorganteFalecido = dadosEndereco.uf;

        return updatedState;
      });

      setCidadeTemp(dadosEndereco.localidade.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
      atualizaCidades(dadosEndereco.uf);

      props.setIsLoading(true);
      setTimeout(() => {
        props.setEtapa(0);
      }, 500);
      setTimeout(() => {
        props.setEtapa(1);
        props.setIsLoading(false);
      }, 1000);

    });
  }

  useEffect(() => {
    if (cidadeTemp) {
      const cidadeDaLista = listaCidades.find(t => t.nome.toUpperCase() == cidadeTemp.toUpperCase());
      setFormData((prevState) => {
        const updatedState = {
          ...prevState,
        };
        updatedState.cidadeJuridicaDocOutorganteFalecido = cidadeDaLista?.nome;
        return updatedState;
      });
      setCidadeTemp(null);
    }
  }, [listaCidades]);

  const cssQuebraPagina = { 'page-break-after': 'auto', 'break-after': 'page', 'width': '100%', 'position': 'relative' };

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <form>
        <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap" }}>

          {/* <div style={cssQuebraPagina}></div> */}

          <Typography variant="h5" gutterBottom>
            Dados pessoais do titular
          </Typography>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nome Completo"
              variant="outlined"
              margin="normal"
              name="nomeCompleto"
              value={formData?.nomeCompleto}
              onChange={handleChange}
              required
              error={!validacao.nomeCompleto}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nome Social"
              variant="outlined"
              margin="normal"
              name="nomeSocial"
              value={formData?.nomeSocial}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nome Artístico"
              variant="outlined"
              margin="normal"
              name="nomeArtistico"
              value={formData?.nomeArtistico}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nome da Banda ou Grupo"
              variant="outlined"
              margin="normal"
              name="pseudonimoColetivo"
              value={formData?.pseudonimoColetivo}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal" required
              error={!validacao.nacionalidade}>
              <InputLabel>Nacionalidade</InputLabel>
              <Select
                name="nacionalidade"
                value={formData?.nacionalidade}
                onChange={(e) => handleChange(e, true)}
                label="Nacionalidade"
              >
                {listaNacionalidade.map((nacionalidade) => (
                  <MenuItem key={nacionalidade.id} value={nacionalidade}>
                    {nacionalidade.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal" disabled={formData?.nacionalidade?.id != 76}>
              <InputLabel>Naturalidade</InputLabel>
              <Select
                name="naturalidade"
                value={formData?.naturalidade}
                onChange={(e) => handleChange(e, true)}
                label="Naturalidade"
              >
                {estados.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Identidade"
              variant="outlined"
              margin="normal"
              name="identidade"
              value={formData?.identidade}
              onChange={handleChange}
              required
              error={!validacao.identidade}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Orgão Expedidor"
              variant="outlined"
              margin="normal"
              name="orgaoExpedidor"
              value={formData?.orgaoExpedidor}
              onChange={handleChange}
              required
              error={!validacao.orgaoExpedidor}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="CPF"
              variant="outlined"
              margin="normal"
              name="cpf"
              value={formData?.cpf}
              onChange={handleChange}
              required={props.nacionalidade == refNacional || formData?.nacionalidade?.id == 76}
              error={!validacao.cpf && (props.nacionalidade == refNacional || formData?.nacionalidade?.id == 76)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Data de Nascimento"
              variant="outlined"
              margin="normal"
              name="dataNascimento"
              type="date"
              value={formData?.dataNascimento || ''}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: '1900-01-01',
                max: getDataAtualISO()
              }}
              required
              error={!validacao.dataNascimento}
              helperText={
                !validacao.dataNascimento
                  ? 'A data de nascimento deve estar entre 01/01/1900 e a data atual.'
                  : ''
              }
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal" required
              error={!validacao.genero}>
              <InputLabel>Gênero</InputLabel>
              <Select
                name="genero"
                value={formData?.genero}
                onChange={(e) => handleChange(e, true)}
                label="Gênero *"
              >
                {generos.map((genero) => (
                  <MenuItem key={genero.id} value={genero.id}>
                    {genero.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal" required
              error={!validacao.estadoCivil}>
              <InputLabel>Estado Civil</InputLabel>
              <Select
                name="estadoCivil"
                value={formData?.estadoCivil}
                onChange={(e) => handleChange(e, true)}
                label="Estado Civil *"
              >
                {estadosCivis.map((estadoCivil) => (
                  <MenuItem key={estadoCivil.id} value={estadoCivil.id}>
                    {estadoCivil.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset" margin="normal">
              <FormLabel component="legend">
                O titular é menor de 15 anos?
              </FormLabel>
              <RadioGroup
                row
                name="menorDe15"
                value={formData?.menorDe15}
                onChange={handleChange}
              >
                <FormControlLabel value={true} control={<Radio />} label="Sim" />
                <FormControlLabel checked={formData?.menorDe15 == undefined || formData?.menorDe15 == 'false'} value={false} control={<Radio />} label="Não" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item sm={6}>
            <FormControl component="fieldset" margin="normal">
              <FormLabel component="legend">O titular é falecido?</FormLabel>
              <RadioGroup
                row
                name="falecido"
                value={formData?.falecido}
                onChange={handleChange}
              >
                <FormControlLabel value={true} control={<Radio />} label="Sim" />
                <FormControlLabel checked={formData?.falecido == undefined || formData?.falecido == 'false'} value={false} control={<Radio />} label="Não" />
              </RadioGroup>
            </FormControl>
          </Grid>

          {formData?.menorDe15 == 'true' &&
            <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap" }}>
              <Grid item xs={12} mt={2}>
                <Typography variant="h6">
                  Dados Pessoais do Representante legal
                </Typography>
                <FormLabel component="legend">
                  Estes campos são obrigatórios caso o titular seja menor de 15 anos.
                </FormLabel>
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  fullWidth
                  label="Nome Completo do representante legal"
                  variant="outlined"
                  margin="normal"
                  name="nomeRepresentanteQuinze"
                  value={formData?.nomeRepresentanteQuinze}
                  onChange={handleChange}
                  required
                  error={!validacao.nomeRepresentanteQuinze && formData?.menorDe15 == 'true'}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  fullWidth
                  label="CPF"
                  variant="outlined"
                  margin="normal"
                  name="cpfRepresentanteQuinze"
                  value={formData?.cpfRepresentanteQuinze}
                  onChange={handleChange}
                  required
                  error={!validacao.cpfRepresentanteQuinze && formData?.menorDe15 == 'true'}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Identidade"
                  variant="outlined"
                  margin="normal"
                  name="rgRepresentanteQuinze"
                  value={formData?.rgRepresentanteQuinze}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Orgão Expedidor"
                  variant="outlined"
                  margin="normal"
                  name="rgOERepresentanteQuinze"
                  value={formData?.rgOERepresentanteQuinze}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <TextField
                  fullWidth
                  label="Celular"
                  variant="outlined"
                  margin="normal"
                  name="celularRepresentanteQuinze"
                  value={formData?.celularRepresentanteQuinze}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  fullWidth
                  label="E-mail"
                  variant="outlined"
                  margin="normal"
                  name="emailRepresentanteQuinze"
                  value={formData?.emailRepresentanteQuinze}
                  onChange={handleChange}
                  type="emailRepresentanteQuinze"
                  helperText="Formato: exemplo@dominio.com"
                />
              </Grid>

            </Grid>
          }

          {formData?.falecido == 'true' &&
            <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap" }}>
              <Grid item xs={12} mt={2}>
                <Typography variant="h6">
                  Dados Pessoais de Outorga de poderes
                </Typography>
                <FormLabel component="legend">
                  Estes campos são obrigatórios somente caso o titular já tenha falecido. Complete os campos a seguir com as informações do sucessor.
                </FormLabel>
              </Grid>
              <Grid item sm={12} xs={12}>
                <Grid item sm={3} xs={12}>
                  <TextField
                    fullWidth
                    label="Data de falecimento do titular:"
                    variant="outlined"
                    margin="normal"
                    name="dtFalecimentoOutorganteFalecido"
                    value={formData?.dtFalecimentoOutorganteFalecido}
                    onChange={handleChange}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    required
                    error={!validacao.dtFalecimentoOutorganteFalecido && formData?.falecido == 'true'}
                  />
                </Grid>
              </Grid>
              <Grid item sm={8} xs={12}>
                <TextField
                  fullWidth
                  label="Nome Completo do Outorgante (Herdeiro/Sucessor/Inventariante):"
                  variant="outlined"
                  margin="normal"
                  name="nomeOutorganteFalecido"
                  value={formData?.nomeOutorganteFalecido}
                  onChange={handleChange}
                  required
                  error={!validacao.nomeOutorganteFalecido && formData?.falecido == 'true'}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="CPF"
                  variant="outlined"
                  margin="normal"
                  name="cpfOutorganteFalecido"
                  value={formData?.cpfOutorganteFalecido}
                  onChange={handleChange}
                  required
                  error={!validacao.cpfOutorganteFalecido && formData?.falecido == 'true'}
                />
              </Grid>

              <Grid item sm={4} xs={12}>
                <FormControl fullWidth variant="outlined" margin="normal" required
                  error={!validacao.nacionalidadeOutorganteFalecido && formData?.falecido == 'true'}>
                  <InputLabel>Nacionalidade</InputLabel>
                  <Select
                    name="nacionalidadeOutorganteFalecido"
                    value={formData?.nacionalidadeOutorganteFalecido}
                    onChange={(e) => handleChange(e, true)}
                    label="Nacionalidade"
                  >
                    {listaNacionalidade.map((nacionalidade) => (
                      <MenuItem key={nacionalidade.id} value={nacionalidade}>
                        {nacionalidade.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Identidade"
                  variant="outlined"
                  margin="normal"
                  name="rgOutorganteFalecido"
                  value={formData?.rgOutorganteFalecido}
                  onChange={handleChange}
                  error={!validacao.rgOutorganteFalecido && formData?.falecido == 'true'}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Orgão Expedidor"
                  variant="outlined"
                  margin="normal"
                  name="rgOEOutorganteFalecido"
                  value={formData?.rgOEOutorganteFalecido}
                  onChange={handleChange}
                  error={!validacao.rgOEOutorganteFalecido && formData?.falecido == 'true'}
                />
              </Grid>
              <Grid item sm={12} xs={12}>
                <FormControl required
                  error={!validacao.estadoCivilOutorganteFalecido && formData?.falecido == 'true'}>
                  <FormLabel>Estado Civil</FormLabel>
                  <RadioGroup
                    row
                    name="estadoCivilOutorganteFalecido"
                    value={formData?.estadoCivilOutorganteFalecido}
                    onChange={handleChange}
                  >
                    <FormControlLabel value="Solteiro" control={<Radio />} label="Solteiro" />
                    <FormControlLabel value="Casado" control={<Radio />} label="Casado" />
                    <FormControlLabel value="Divorciado" control={<Radio />} label="Divorciado" />
                    <FormControlLabel value="Viúvo" control={<Radio />} label="Viúvo" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item sm={12} xs={12}>
                <TextField
                  fullWidth
                  label="Natureza jurídica do documento: (Exemplo: Alvará, Carta de Adjudicação, Formal de Partilha, etc):"
                  variant="outlined"
                  margin="normal"
                  name="naturezaJuridicaDocOutorganteFalecido"
                  value={formData?.naturezaJuridicaDocOutorganteFalecido}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Vara"
                  variant="outlined"
                  margin="normal"
                  name="varaOutorganteFalecido"
                  value={formData?.varaOutorganteFalecido}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Comarca"
                  variant="outlined"
                  margin="normal"
                  name="comarcaOutorganteFalecido"
                  value={formData?.comarcaOutorganteFalecido}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Data"
                  variant="outlined"
                  margin="normal"
                  name="dataOutorganteFalecido"
                  type="date"
                  value={formData?.dataOutorganteFalecido}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item sm={12} xs={12}>
                <Grid item sm={4} xs={12}>
                  <TextField
                    fullWidth
                    label="CEP"
                    variant="outlined"
                    margin="normal"
                    name="cepOutorganteFalecido"
                    value={formData?.cepOutorganteFalecido}
                    onChange={handleChange}
                    error={!validacao.cepOutorganteFalecido && formData?.falecido == 'true'}
                    required
                  />
                </Grid>
              </Grid>

              <Grid item sm={6} xs={12}>
                <TextField
                  fullWidth
                  label="Endereço"
                  variant="outlined"
                  margin="normal"
                  name="endecoOutorganteFalecido"
                  value={formData?.endecoOutorganteFalecido}
                  onChange={handleChange}
                  error={!validacao.endecoOutorganteFalecido && formData?.falecido == 'true'}
                  required
                />
              </Grid>
              <Grid item sm={2} xs={12}>
                <TextField
                  fullWidth
                  label="Número"
                  variant="outlined"
                  margin="normal"
                  name="numeroOutorganteFalecido"
                  value={formData?.numeroOutorganteFalecido}
                  onChange={handleChange}
                  error={!validacao.numeroOutorganteFalecido && formData?.falecido == 'true'}
                  required
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Complemento"
                  variant="outlined"
                  margin="normal"
                  name="complementoOutorganteFalecido"
                  value={formData?.complementoOutorganteFalecido}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={2} md={2}>
                <FormControl fullWidth variant="outlined" margin="normal" required
                  error={!validacao.estadoOutorganteFalecido && formData?.falecido == 'true'}>
                  <InputLabel>Estado</InputLabel>
                  <Select
                    name="estadoOutorganteFalecido"
                    value={formData?.estadoOutorganteFalecido}
                    onChange={handleChange}
                    label="Estado"
                  >
                    {estados.map((estado) => (
                      <MenuItem key={estado.id} value={estado.id}>
                        {estado.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={5} md={5}>
                <FormControl fullWidth variant="outlined" margin="normal"
                  required
                  error={!validacao.cidadeJuridicaDocOutorganteFalecido && formData?.falecido == 'true'}>
                  <InputLabel>Cidade</InputLabel>
                  <Select
                    name="cidadeJuridicaDocOutorganteFalecido"
                    value={formData?.cidadeJuridicaDocOutorganteFalecido}
                    onChange={handleChange}
                    label="Cidade"
                  >
                    {listaCidades.map((cidade) => (
                      <MenuItem key={cidade.id} value={cidade.nome}>
                        {cidade.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={5} md={5}>
                <TextField
                  fullWidth
                  label="Bairro"
                  variant="outlined"
                  margin="normal"
                  name="bairroJuridicaDocOutorganteFalecido"
                  value={formData?.bairroJuridicaDocOutorganteFalecido}
                  onChange={handleChange}
                  required
                  error={!validacao.bairroJuridicaDocOutorganteFalecido && formData?.falecido == 'true'}
                />
              </Grid>

            </Grid>
          }

          {props.finalizado && <Grid item xs={12}>
            <div style={cssQuebraPagina}></div>

            <Box sx={{ position: 'relative', height: '10px' }}>
              <img src="logo.png" alt="Minha Logo" style={{ position: 'absolute', top: 10, right: -50, height: '30px' }} />
            </Box>
          </Grid>
          }

          <Grid item xs={12} mt={2}>
            <Typography variant="h6">
              Informações adicionais sobre sua carreira
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormLabel component="legend">
              Existe algo sobre sua carreira que precisamos saber? Estas informações servirão para a análise que precisamos fazer
              para que possamos avaliar seu pedido de filiação.
            </FormLabel>
            <TextField
              fullWidth
              label="Nos informe aqui..."
              variant="outlined"
              margin="normal"
              name="sobreCarreira"
              value={formData?.sobreCarreira}
              onChange={handleChange}
              multiline
              rows={4}
              inputProps={{ maxLength: 250 }}
              helperText="Máximo de 250 caracteres"
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormLabel component="legend">
              Suas músicas ou participações em gravações já estão sendo executadas publicamente?
            </FormLabel>
            <FormControl fullWidth variant="outlined" margin="normal">
              <InputLabel>Se sim, informe onde</InputLabel>
              <Select
                name="musicasPublicas"
                value={formData?.musicasPublicas}
                onChange={handleChange}
                label="Se sim, informe onde"
              >
                {listaPartirticipacoes.map((item) => (
                  <MenuItem key={item.id} value={item.nome}>
                    {item.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormLabel component="legend">
              Nos informe os títulos e ou links de publicações de suas músicas
              ou de gravações que você tenha participado, mesmo que em rede
              sociais, pois estas informações servirão para a análise que
              precisamos fazer para que possamos avaliar seu pedido de filiação.
            </FormLabel>
            <TextField
              fullWidth
              label="Nos informe aqui..."
              variant="outlined"
              margin="normal"
              name="links"
              value={formData?.links}
              onChange={handleChange}
              multiline
              rows={4}
              inputProps={{ maxLength: 250 }}
              helperText="Máximo de 250 caracteres"
            />
          </Grid>


        </Grid>
      </form>

      <Dialog
        open={dialogDocInvalido}
        onClose={() => setDialogDocInvalido(false)}
        aria-labelledby="dialog-titulo"
      >
        <DialogTitle id="dialog-titulo">CPF inválido</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Caro(a) Usuário o texto inserido não é um CPF válido.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogDocInvalido(false)} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
});

export default FormularioDados;
